module.exports = __webpack_public_path__ + "img/T1D_xh10.47d71d35.png";